import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { marcoOpSsh_item } from "../../../json/marcoOpSsh";
import "./stylessh.css";

const MarcoOpSsh = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Instrumentos Normativos SSH</h1>
            <hr className="tramitehr" />
          </div>
        </div>
      </div>
      <div className="row overflow-auto">
        <table className="table-responsive table-bordered">
          <thead>
            <tr>
              <th className="colortabla" scope="col">Instrumentos</th>
              {marcoOpSsh_item[0].marcoOpSsh_item_years.map((item) => (
                <th className="colortabla" scope="col" key={item.marcoOpSsh_item_year}>
                  {item.marcoOpSsh_item_year}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {marcoOpSsh_item.map((instrumento, index) => (
              <tr className="text-size-font" key={index}>
                <th className="text-size-font fs14 colortabla" scope="row">{instrumento.marcoOpSsh_item_instrumento}</th>
                {instrumento.marcoOpSsh_item_years.map((year) => (
                  <td className="text-size-font fs14" key={year.marcoOpSsh_item_year}>
                    {Array.isArray(year.marcoOpSsh_item_contenido) ? (
                      year.marcoOpSsh_item_contenido.map((contenido, index) => (
                        <div key={index}>{contenido}</div>
                      ))
                    ) : (
                      <div>{year.marcoOpSsh_item_contenido}</div>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MarcoOpSsh;
